import { useAppSelector } from '@redux/hooks';

export const useLiteStorefront = () => {
	const purchaseStatus = useAppSelector(
		(state) => state.vendor.vendor?.purchaseStatus,
	);

	return Boolean(purchaseStatus !== 'PAID');
};
